import ReactMarkdown from 'react-markdown';

import { FeatureFlag, PageTitles } from '@revelio/core';

import { ContentWrapper } from '../../../shared/ui/content-wrapper/content-wrapper';
import { useUnleashFlag } from '../../../shared/unleash-flags/use-unleash-flag';
import DashboardPage from '../../DashboardPage';
import { TrailPageConent } from './components/trial-page-content';
import trialPageContent from './markdown/data-enrichment-content.md';

export const DataEnrichmentTrialPage = () => {
  const isNewDashboardLayout = useUnleashFlag(FeatureFlag.DashboardNewLayout);
  const title = isNewDashboardLayout
    ? [PageTitles.DATA_ENRICHMENT]
    : [PageTitles.DELIVERABLES, PageTitles.DATA_ENRICHMENT];

  return (
    <DashboardPage title={title} loading={false} scrollY={true}>
      <TrailPageConent>
        <ContentWrapper>
          <ReactMarkdown>{trialPageContent}</ReactMarkdown>
        </ContentWrapper>
      </TrailPageConent>
    </DashboardPage>
  );
};
